// InvoiceAndNotes.jsx
import React from 'react';

export default function NotesRow({
  notes,
  onNotesChange,
  notesErrorText,
  required,
  disabled = false
}) {
  return (
    <>
      <div className="form-input-expense" style={{ marginTop: 20 }}>
        <label className="form-input-label-expense">Notes*</label>
        <textarea
          name="notes"
          className="form-input-field-expense"
          placeholder="1000 characters left"
          rows={8}
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          style={{ minHeight: 55, resize: 'vertical' }}
          required={required}
          disabled={disabled}
        />
        {notesErrorText ? <div className="error-text">{notesErrorText}</div> : null}
      </div>
    </>
  );
}
